import { render, staticRenderFns } from "./TextAlignRightIcon.vue?vue&type=template&id=e84a7864&"
import script from "./TextAlignRightIcon.vue?vue&type=script&lang=js&"
export * from "./TextAlignRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports